import React, { useState } from "react";
import { IconAngleArrowRight } from "../../../common/icons";

const Cards = (props) => {
  const {
    id = "",
    title = "",
    count = "",
    isCardActive = true,
    onCardClicked = () =>
      console.error("You passed no action to the component"),
  } = props;

  return (
    <React.Fragment>
      <div className="col-md-3 mb-1">
        <div
          className={`ncard d-flex flex-column justify-content-between p-10 ${
            isCardActive ? "active" : ""
          }`}
          onClick={onCardClicked}
        >
          <div className="d-flex align-items-center">
            <div className="mr-1 sbox sbox--default px-2 h-100">{count}</div>
            <div>{title}</div>
            <div className="ml-auto">
              <IconAngleArrowRight />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Cards;
